import { LangEnum } from '../enums/Lang.enum';

export class Lang {
  constructor(
    public readonly id: number,
    public readonly libelle: string,
    public readonly code: LangEnum,
  ) {}
}
